import pluralize from "pluralize"

export const LEARN_MORE_URL =
  "https://help.kit.com/en/articles/15460643-subscriber-signals-how-to-access-and-getting-started"

// Mirrors Accounts::SignalsAccessLevel::STATES
export const SIGNALS_STATE = {
  NON_PRO: "non_pro",
  PRO_TRIAL: "pro_trial",
  OPT_IN_REQUIRED: "opt_in_required",
  IN_ENRICHMENT_QUEUE: "in_enrichment_queue",
  ENRICHING: "enriching",
  ENABLED: "enabled"
}

const OPT_IN_AVAILABILITY = () => "Included in your Pro plan at no extra cost."
const OPT_IN_CTA = { label: "Turn on Signals", action: "optIn" }

export const UPGRADE_TO_OPT_IN_LABEL = "Upgrade to turn on Signals"

export const END_TRIAL_EARLY_CAPTION =
  "Signals isn’t available during your free Pro trial. You’ll be immediately upgraded to Pro to turn it on."

export const ACCESS_GATED_CONTENT = {
  [SIGNALS_STATE.NON_PRO]: {
    availability: () => "You need to be on a Pro plan to get access.",
    cta: { label: "Upgrade to Pro", action: "upgrade" }
  },
  [SIGNALS_STATE.PRO_TRIAL]: {
    availability: ({ trialDaysRemaining }) =>
      `Available once your Pro trial ends: ${pluralize(
        "day",
        trialDaysRemaining,
        true
      )} left.`,
    cta: { label: "Available after your trial", disabled: true }
  },
  [SIGNALS_STATE.OPT_IN_REQUIRED]: {
    availability: OPT_IN_AVAILABILITY,
    cta: OPT_IN_CTA
  }
}

export const ACCESS_GATED_STATES = Object.keys(ACCESS_GATED_CONTENT)

export const ENROLLMENT_STATUS_STATES = [
  SIGNALS_STATE.IN_ENRICHMENT_QUEUE,
  SIGNALS_STATE.ENRICHING,
  SIGNALS_STATE.ENABLED
]

export const getOptInEligibleStates = allowTrialSignalsOptIn =>
  allowTrialSignalsOptIn
    ? [SIGNALS_STATE.OPT_IN_REQUIRED, SIGNALS_STATE.PRO_TRIAL]
    : [SIGNALS_STATE.OPT_IN_REQUIRED]

export const getEnrollmentCtaLabel = ({ state, hasCard }) => {
  switch (state) {
    case SIGNALS_STATE.NON_PRO:
      return ACCESS_GATED_CONTENT[SIGNALS_STATE.NON_PRO].cta.label
    case SIGNALS_STATE.PRO_TRIAL:
      return hasCard ? OPT_IN_CTA.label : UPGRADE_TO_OPT_IN_LABEL
    case SIGNALS_STATE.OPT_IN_REQUIRED:
      return OPT_IN_CTA.label
    default:
      return null
  }
}
